import React from 'react';
import { motion } from 'framer-motion';
import { PAIN_BLOCKS } from './salesData';
export function PainSection() {
  return <section id="problema" className="bg-cream py-14 sm:py-20" data-id="element-253" data-mp="38wlv6wefoyjb">
      <div className="mx-auto max-w-5xl px-5" data-id="element-254" data-mp="2uyoupowv07zd">
        <h2 className="mx-auto max-w-[22ch] text-center font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[28ch] sm:text-[2.4rem]" data-id="element-255" data-mp="2uxvw5b820osb">
          Tener más recetas no te acerca a tu <span className="text-gold" data-id="element-256" data-mp="2l69eaw17nrgl">primera venta</span>.
        </h2>
        <p className="mx-auto mt-4 max-w-[46ch] text-center font-sans text-[0.92rem] leading-relaxed text-taupe sm:max-w-2xl sm:text-[1rem]" data-id="element-257" data-mp="2pzudgrejirhd">
          Si alguna vez pensaste en vender lo que cocinás y nunca terminaste de arrancar, seguro te
          suena alguna de estas situaciones.
        </p>

        <ul className="mt-9 grid gap-3.5 sm:grid-cols-2" data-id="element-258" data-mp="22at3gzq2789z">
          {PAIN_BLOCKS.map((block, i) => <motion.li key={block} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 5) * 0.04
        }} className="flex h-full gap-3 rounded-2xl border border-stone bg-white p-4 shadow-[0_10px_30px_-24px_rgba(56,37,34,0.5)] sm:p-5" data-id="element-259" data-mp="2781kuy3dv8a6" data-mpi={i}>
              <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-coral" aria-hidden data-id="element-260" data-mp="38vzyl6u55gsd" />
              <p className="font-sans text-[0.88rem] leading-relaxed text-charcoal/85 sm:text-[0.93rem]" data-id="element-261" data-mp="33xq1gqouw644">
                {block}
              </p>
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-sand px-6 py-7 text-center" data-id="element-262" data-mp="3dvw08zfd8w4r">
          <p className="font-display text-[1.2rem] font-bold leading-snug tracking-tight text-charcoal sm:text-[1.55rem]" data-id="element-263" data-mp="2q61n0gr4x5jz">
            El problema no es la falta de información.
            <span className="block text-gold" data-id="element-264" data-mp="2l4ueugl2y4cs">
              Es la falta de selección, de orden y de sistema.
            </span>
          </p>
        </div>
      </div>
    </section>;
}